export default {"src":"/_next/static/media/copy-slateus.5367fb57.svg","height":32,"width":31};